const awsConfig = {
  aws_project_region: process.env.NEXT_PUBLIC_AWS_REGION,
  aws_cognito_identity_pool_id: process.env.NEXT_PUBLIC_CLOUDWATCH_COG_GROUP,
  aws_cognito_region: process.env.NEXT_PUBLIC_AWS_REGION,
};

export default awsConfig;
